module.exports = __webpack_public_path__ + "themes/mf/img/star@3x.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/star@3x.png
// module id = 112
// module chunks = 3